var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7357 5.96021L20.6373 15L29.7357 24.0398C29.9002 23.696 30 23.316 30 22.9101V7.08983C30 6.68395 29.9002 6.30397 29.7357 5.96021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3633 4.45312H2.63671C2.23083 4.45312 1.85085 4.55291 1.50708 4.71738L13.1358 16.2875C14.164 17.3157 15.836 17.3157 16.8642 16.2875L28.4929 4.71738C28.1491 4.55291 27.7692 4.45312 27.3633 4.45312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.264258 5.96021C0.0997852 6.30397 0 6.68395 0 7.08983V22.9101C0 23.316 0.0997852 23.6961 0.264258 24.0398L9.36264 15L0.264258 5.96021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 16.2429L18.1071 17.5304C16.3938 19.2436 13.6061 19.2436 11.8929 17.5304L10.6055 16.2429L1.50708 25.2827C1.85085 25.4472 2.23083 25.547 2.63671 25.547H27.3633C27.7692 25.547 28.1491 25.4472 28.4929 25.2827L19.3945 16.2429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.50de617a.svg";
export { ForwardRef as ReactComponent };